import { render, staticRenderFns } from "./MyPlacementsWidget.vue?vue&type=template&id=74477f34"
import script from "./MyPlacementsWidget.vue?vue&type=script&lang=js"
export * from "./MyPlacementsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports